import { PageLoadingIndicator } from '@wrisk/ui-components'
import { isNil } from 'lodash-es'
import React, { FunctionComponent, useState } from 'react'
import { useAsync } from 'react-async-hook'
import { generatePath, useNavigate, useSearchParams } from 'react-router'

import { AppPath } from '../AppPath'
import { AnonymousPrincipal } from '../authentication'
import { RetrievePath } from './RetrievePath'
import { RetrieveTokenError } from './RetrieveTokenError'

export interface RetrieveTokenProps {
  principal: AnonymousPrincipal
}

export const RetrieveToken: FunctionComponent<RetrieveTokenProps> = ({ principal }) => {
  const navigate = useNavigate()

  const [params] = useSearchParams()

  const token = params.get('token') ?? undefined
  const externalReference = params.get('ref') ?? undefined

  const [error, setError] = useState<Error | undefined>()

  useAsync(
    async () => {
      setError(undefined)

      if (token) {
        await principal.update({ token })
      }

      navigate(
        externalReference
          ? generatePath(RetrievePath.RETRIEVE_PROPOSAL, {
              externalReference,
            })
          : AppPath.HOME,
      )
    },
    [token],
    { onError: setError },
  )

  return isNil(error) ? (
    <PageLoadingIndicator />
  ) : (
    <RetrieveTokenError principal={principal} error={error} />
  )
}
